import React, { useState } from "react";
import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";

import { store } from "../store";
import { store as globalStore } from "@components/VerticalLayout/store";

import { CustomIcons } from "./CustomIcons";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";
import { CustomPaymentMethodIcons } from "./CustomPaymentMethodIcons";
import PaymentForm from "./PaymentForm";
import { useAuthHeader } from "../../../../../api/headersKeycloak";
import { useFetchGlobal } from "../../../../../api/hooks";
import { useSyncDefaultSettingPayment, usePaymentModified } from "./hooks";

export function PaymentMethod() {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();

    const { fetchGlobal } = useFetchGlobal();
    const { franchiseID } = useSnapshot(globalStore);
    const { defaultSetting, isPaymentModified, paymentMethod } = useSnapshot(
        store
    );
    const [skipFirstEffect, setSkipFirstEffect] = useState(false);

    const [filterActive, setLocalFilterActive] = useState<boolean>(false);
    const [isAddPaymentClicked, setIsAddPaymentClicked] = useState<boolean>(
        false
    );
    const [dataIsUpdated, setDataIsUpdated] = useState<boolean | number>(false);
    const [data, setData] = useState<any>({});
    const [rowData, setRowData] = useState<any>({});

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 1,
            columnName: t("Payment method"),
            customJsx: (e: any) => {
                return (
                    <CustomColumnDisplay
                        text={t(e.selectedRow["Type of payment method"])}
                    />
                );
            },
        },
        {
            indexOFColumn: 0,
            columnName: t("Display name"),
            customJsx: (e: any) => {
                return (
                    <CustomColumnDisplay
                        text={t(e.selectedRow["Display name"])}
                    />
                );
            },
        },

        {
            indexOFColumn: 2,
            columnName: t("Sales support"),
            customJsx: (e: any) => <CustomPaymentMethodIcons e={e} />,
        },
        {
            indexOFColumn: 3,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setRowData={setRowData}
                    setIsAddPaymentClicked={setIsAddPaymentClicked}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                />
            ),
        },
    ];
    useSyncDefaultSettingPayment(data, defaultSetting);
    usePaymentModified(
        isPaymentModified,
        skipFirstEffect,
        setSkipFirstEffect,
        franchiseID,
        paymentMethod,
        setIsAddPaymentClicked,
        setDataIsUpdated,
        dataIsUpdated,
        fetchGlobal
    );

    return (
        <div>
            <h2 className="mt-3 ml-3">{t("Payment method")}</h2>
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: isAddPaymentClicked
                        ? "2fr 1fr "
                        : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    requestHeader={{
                        ...getAuthHeader,
                    }}
                    canMovedCheckboxLeftOnExpand
                    url={`${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/getData?type=paymentMethod&franchiseId=${franchiseID}`}
                    setData={setData}
                    canSelect
                    customSelect
                    canResize
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={() => <></>}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight={"450px"}
                    maxHeight={"450px"}
                    name="tva"
                />
                {isAddPaymentClicked ? (
                    <PaymentForm
                        setIsAddPaymentClicked={setIsAddPaymentClicked}
                        paymentMethod={rowData}
                        setIsDataUpdated={setDataIsUpdated}
                        isDataUpdated={dataIsUpdated}
                        data={data.data}
                        setRowData={setRowData}
                    />
                ) : null}
            </div>
        </div>
    );
}
